module.exports = __webpack_public_path__ + "static/assets/4033eb95db1e662af3cf1e468219cbce.png";